import StdForm from '@shared/components/forms/auto-form/std-form/std-form.vue';
import { Component, Prop } from 'vue-property-decorator';
import EntityTableProvider from '@shared/components/tables/entity-table-provider/entity-table-provider.vue';
import EntityTable from '@shared/components/tables/entity-table/entity-table.vue';
import BpcPageTitle from '@shared/layouts/components/page-title/page-title.vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import EntityDeleteModalProvider from '@shared/components/modals/entity-delete-modal-provider/entity-delete-modal-provider.vue';
import ConfirmationModal from '@shared/components/modals/confirmation-modal/confirmation-modal.vue';
import { ValidationObserver } from 'vee-validate';
import { mixins } from 'vue-class-component';
import AbstractTable from '@shared/components/tables/abstract-table/abstract-table';
import StdFilter from '@shared/components/filters/std-filter/std-filter.vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faSync } from '@fortawesome/free-solid-svg-icons';
import { Account } from '@modules/accounting/interfaces/account';
import DrawerModal from '@shared/components/modals/drawer-modal/drawer-modal.vue';
import { AccountingIntegrationSettings } from '@accounting-integrations/interfaces/accounting-integrations';
import AccountSyncModal from '@accounting/components/others/account-sync-modal/account-sync-modal.vue';
library.add(faSync);

@Component({
  name: 'bpc-account-table',
  components: {
    'bpc-entity-table-provider': EntityTableProvider,
    'bpc-entity-table': EntityTable,
    'bpc-page-title': BpcPageTitle,
    'font-awesome-icon': FontAwesomeIcon,
    'bpc-entity-delete-modal-provider': EntityDeleteModalProvider,
    'bpc-confirmation-modal': ConfirmationModal,
    'bpc-std-form': StdForm,
    'bpc-std-filter': StdFilter,
    ValidationObserver,
    'bpc-account-sync-modal': AccountSyncModal,
    'bpc-drawer-modal': DrawerModal,
  },
})
export default class AccountTable extends mixins(AbstractTable) {
  // PROPS
  @Prop(String) readonly title: string;
  @Prop(String) readonly subtitle: string;

  // DATA
  public entity: Account = null;
  public entityName = 'account';
  public pluralEntityName = 'accounts';
  public showDrawerSettingSection: boolean = false;
  public showSettingForm: boolean = false;
  public permissionEntityNameToUse = 'accounts';
  public showSyncWithExactModal = false;
  public showSyncWithOdooModal = false;

  public flagsToCheckBeforeLoadEntities: string[] = [
    'configLoaded',
    'filtersLoaded',
    'paginationLoaded',
    'orderLoaded',
    'urlParametersLoaded',
  ];

  public customPageActions = {
    bulkSyncWithExact: {
      activated: false,
      type: 'action',
      icon: 'cloud-download-alt', //'times',
      variant: 'primary',
      text: 'bulk_sync_with_exact',
      show: false,
      event: 'bulk-sync-with-exact',
      selectElements: true,
      tag: 'left',
      permissions: ['manage_accounts'],
    },
    bulkSyncWithOdoo: {
      activated: false,
      type: 'action',
      icon: 'cloud-download-alt', //'times',
      variant: 'primary',
      text: 'bulk_sync_with_odoo',
      show: false,
      event: 'bulk-sync-with-odoo',
      selectElements: true,
      tag: 'left',
      permissions: ['manage_accounts'],
    },
  };

  public customRowActions = {
    syncWithExact: {
      activated: false,
      type: 'action',
      icon: 'cloud-download-alt',
      show: false,
      event: 'sync-with-exact',
      text: 'sync_with_exact',
      permissions: ['manage_accounts'],
    },
  };

  public accountsToSync = [];

  // COMPUTED
  get accountingIntegrationSettings(): AccountingIntegrationSettings {
    if (this.$modulesService.hasModuleActivated('accounting_integrations')) {
      return this.$store.getters['centerSettings/accountingIntegrationSettings'];
    }

    return null;
  }

  get syncService(): string {
    return this.accountingIntegrationSettings?.sync_service;
  }

  // LIFECYCLE
  // created() {}
  // mounted() {}
  // updated() {}
  // destroyed() {}

  // METHODS
  setEntityAttributesAfterSave() {
    const newEntity = {} as Account;
    Object.keys(this.entity).forEach(key => {
      this.$set(newEntity, key, null);
    });

    this.$set(newEntity, 'status', this.entity.status);
    this.$set(this.$refs.stdForm, 'formModel', newEntity);

    this.showForm = true;
    this.showDrawerSection = true;
  }

  customOnPageAction($event: string) {
    switch ($event) {
      case 'bulk-sync-with-exact':
        this.onBulkSyncWithExact();
        break;
      case 'bulk-sync-with-odoo':
        this.onBulkSyncWithOdoo();
        break;
    }
  }

  customOnRowAction($event: { event: string; item: any }) {
    switch ($event.event) {
      case 'sync-with-exact':
        this.onSyncWithExact($event.item);
        break;
    }
  }

  onBulkSyncWithExact() {
    this.accountsToSync = this.selection;
    this.showSyncAccountWithExactModal();
  }

  onBulkSyncWithOdoo() {
    this.accountsToSync = this.selection;
    this.showSyncAccountWithOdooModal();
  }

  showSyncAccountWithExactModal() {
    console.log('showSyncAccountWithExactModal', this.accountsToSync);
    this.showSyncWithExactModal = true;
  }
  showSyncAccountWithOdooModal() {
    console.log('showSyncAccountWithOdooModal', this.accountsToSync);
    this.showSyncWithOdooModal = true;
  }

  closeSyncAccountModal() {
    this.accountsToSync = [];
    this.showSyncWithExactModal = false;
    this.showSyncWithOdooModal = false;
  }

  onSyncWithExact(item) {
    console.log('onSyncWithExact', item);
    this.accountsToSync = [item.item.id];
    this.showSyncAccountWithExactModal();
  }

  onSyncedAccounts() {
    this.$refs.provider.getEntities();
  }

  extendUpdatePageActions() {
    if (this.config) {
      for (const activatedPageAction of this.config.data.activatedPageActions) {
        if (this.customPageActions[activatedPageAction]) {
          this.customPageActions[activatedPageAction].activated = true;
        }
      }
    }

    this.customPageActions.bulkSyncWithExact.show =
      this.$refs.provider &&
      this.$refs.provider.queryConfig.params.status !== 'trash' &&
      !this.$refs.provider.queryConfig.params.onlyTrashed &&
      this.$modulesService.hasModuleActivated('accounting_integrations') &&
      this.syncService === 'exact';

    this.customPageActions.bulkSyncWithOdoo.show =
      this.$refs.provider &&
      this.$refs.provider.queryConfig.params.status !== 'trash' &&
      !this.$refs.provider.queryConfig.params.onlyTrashed &&
      this.$modulesService.hasModuleActivated('accounting_integrations') &&
      this.syncService === 'odoo';
  }

  extendUpdateRowActions(entity: any) {
    entity.actions.syncWithExact.show =
      this.$modulesService.hasModuleActivated('accounting_integrations') &&
      this.syncService === 'exact';
  }
}
